module.exports = __webpack_public_path__ + "static/media/MobileWorkshopMICROSERVICEUSANDOSTREAMINGPARABIGDATAKAFKANODEJSGOGCP.5eee34d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/microservice/MobileWorkshopMICROSERVICEUSANDOSTREAMINGPARABIGDATAKAFKANODEJSGOGCP.png
// module id = 99
// module chunks = 0